import * as React from "react"
import { motion } from "framer-motion"
import styles from "./navigation.module.scss"
import { NavLink } from "react-router"
import { pages } from "../../general.models"
import { useTranslation } from "react-i18next"

const variants = {
    open: {
        transition: { staggerChildren: 0.07, delayChildren: 0.2 }
    },
    closed: {
        transition: { staggerChildren: 0.05, staggerDirection: -1 }
    }
}

const itemVariants = {
    open: {
        y: 0,
        opacity: 1,
        transition: {
            y: { stiffness: 1000, velocity: -100 }
        }
    },
    closed: {
        y: 50,
        opacity: 0,
        transition: {
            y: { stiffness: 1000 }
        }
    }
}

export const Navigation = ({closeOnNavigate = ()=>{}}) => {
    const navigationItems = pages;
    const [t] = useTranslation();
    return (
        <motion.ul className={styles.sideNavigation} variants={variants}>
            {navigationItems.map((item, i) => (
                <motion.li
                    key={`side-navigation-item${i}`}
                    className={styles.li}
                    variants={itemVariants}
                    whileHover={{ x: -10}}
                    whileTap={{ x: -10 }}
                    style={{
                        '--background-image': `url(${item.image})`,
                        '--hover-background-image': `url(${item.hoverImage})`,
                    }}
                >
                    {/* <div className={styles.iconPlaceholder} /> */}
                    <NavLink to={item.linkTo} onClick={()=>closeOnNavigate()} className={styles.link} >{t(item.text)}</NavLink>
                </motion.li>
            ))}
        </motion.ul>
    )

};